import { Inline } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { DropdownItem } from '@databases/atlaskit/DropdownMenu';
import React, { FunctionComponent, useMemo } from 'react';

interface ActionDisableCondition {
  isConditionActive: boolean;
  message: string;
}

export interface ActionItem {
  id: string;
  name: string;
  onClick: (e: React.MouseEvent | React.KeyboardEvent) => void;
  icon: React.ReactNode;
  disableConditions?: ActionDisableCondition[];
}

interface DropdownItemWithTooltipProps {
  item: ActionItem;
}

export const DropdownItemWithTooltip: FunctionComponent<DropdownItemWithTooltipProps> = ({
  item,
}) => {
  const tooltipContent = useMemo(() => {
    const activeCondition = item.disableConditions?.find(
      (condition) => condition.isConditionActive
    );
    if (activeCondition) {
      return activeCondition.message;
    }
    return '';
  }, [item.disableConditions]);

  return (
    <Tooltip
      key={item.id}
      content={tooltipContent}
      position="right"
      ignoreTooltipPointerEvents
      testId="view-actions-tooltip"
    >
      <DropdownItem
        onClick={item.onClick}
        isDisabled={
          !!item.disableConditions?.some((condition) => condition.isConditionActive)
        }
        testId={`view-actions-${item.id}`}
      >
        <Inline alignBlock="center" space="space.150">
          {item.icon}
          {item.name}
        </Inline>
      </DropdownItem>
    </Tooltip>
  );
};
